export interface IEditDialogData {
  Name: string;
  Color: string;
  Component: string;
}

export interface ICategoryTreeNode {
  Id: string;
  Name: string;
  TreePath?: string;
  Children: ICategoryTreeNode[];
}

export class ICategoryCheckItemNode {
  id: string;
  selected: boolean; 
  item: string;
  children: ICategoryCheckItemNode[];
}

export class ICategoryItemFlatNode {
  id: string;
  item: string;
  level: number;
  expandable: boolean;
}

export interface ICategoryTreeSelection {
  ids: string[];
  selected: boolean;
  checklist: ICategoryItemFlatNode[];
}
